export const AREC_ORGANIZATION_IDS = {
	DEVELOP: '681c6c3acf921f9d8e84156d',
	STAGING: '680b668a79fc72ca9c41c1d6',
	PRODUCTION: '68371183ee2efb5859ac5bfa',
};
